/**
 * Math Tab - Dedicated tab for math expressions editing
 */

import { Box } from '@mui/material';
import { LessonV1_SpineTagsPrediction } from '../../types';
import MathExpressionsSection from './MathExpressionsSection';

interface MathTabProps {
  prediction: LessonV1_SpineTagsPrediction;
  onDirtyStateChange?: (isDirty: boolean) => void;
  triggerSave?: boolean;
}

export default function MathTab({ prediction, onDirtyStateChange, triggerSave }: MathTabProps) {
  return (
    <Box>
      <MathExpressionsSection
        lessonId={prediction.id}
        lessonName={prediction.lesson_name}
        lessonGrade={prediction.lesson_grade?.toString()}
        onDirtyStateChange={onDirtyStateChange}
        triggerSave={triggerSave}
      />
    </Box>
  );
}